export default __webpack_public_path__ + "static/media/gallery_01.0683bb49.jpg";